
import DistributionListComponent from "../../../components/distributions/Index.vue";

export default {
  components: {
    DistributionListComponent,
  },
};
